import * as React from "react"
import AirplaneDown from "@kiwicom/orbit-components/lib/icons/AirplaneDown"
import Train from "@kiwicom/orbit-components/lib/icons/Train"
import Bus from "@kiwicom/orbit-components/lib/icons/Bus"

export const PLACE_TYPE = {
  SUBDIVISION: 1,
} as const

export const PART_TYPES = {
  FLIGHT: "flight",
  TRAIN: "train",
  BUS: "bus",
} as const

export type PART_TYPE = "flight" | "train" | "bus"
export type PART_CONFIG_TYPE = Partial<
  Record<
    PART_TYPE,
    {
      type: PART_TYPE
      icon?: React.ReactElement
      logo: string
    }
  >
>

export const RESERVATION_PART_CONFIG: PART_CONFIG_TYPE = {
  flight: {
    type: PART_TYPES.FLIGHT,
    icon: <AirplaneDown ariaHidden size="small" className="ItineraryPart-milestoneIcon _flight" />,
    logo: "skypicker",
  },
  train: {
    type: PART_TYPES.TRAIN,
    icon: <Train ariaHidden size="small" className="ItineraryPart-milestoneIcon _train" />,
    logo: "train",
  },
  bus: {
    type: PART_TYPES.BUS,
    icon: <Bus ariaHidden size="small" className="ItineraryPart-milestoneIcon _bus" />,
    logo: "bus",
  },
}

export const RESERVATION_ERRORS = {
  // @ts-expect-error: Flow to TS migration.
  REQUIRED: __("forms.errors.is_required"),
  // @ts-expect-error: Flow to TS migration.
  REQUIRED_EMAIL: __("booking.passenger.email.required"),
  // @ts-expect-error: Flow to TS migration.
  INVALID: __("forms.errors.invalid_value"),
  // @ts-expect-error: Flow to TS migration.
  INVALID_EMAIL: __("booking.passenger.email.invalid"),
  // @ts-expect-error: Flow to TS migration.
  NOT_SUPPORTED: __("forms.errors.not_supported"),
  // @ts-expect-error: Flow to TS migration.
  EXPIRED: __("forms.expired"),
  // @ts-expect-error: Flow to TS migration.
  EXPIRES_BEFORE_DEPARTURE: __("forms.expires_before_departure"),
  // @ts-expect-error: Flow to TS migration.
  RANGE: __("forms.must_be_in_range"),
  // @ts-expect-error: Flow to TS migration.
  LEAST: __("forms.must_be_at_least"),
  // @ts-expect-error: Flow to TS migration.
  SHORT: __("forms.too_short"),
  // @ts-expect-error: Flow to TS migration.
  LONG: __("forms.too_long"),
  // @ts-expect-error: Flow to TS migration.
  UNSUPPORTED_CHARACTERS: __("booking.passenger.unsupported_characters"),
  // @ts-expect-error: Flow to TS migration.
  INVALID_BIRTHDAY: __("forms.errors.invalid_birthday"),
  // @ts-expect-error: Flow to TS migration.
  CURRENCIES_WHITELIST: __("common.payment.provider_supported_currency"),
  // @ts-expect-error: Flow to TS migration.
  INVALID_EXPIRATION_DATE: __("forms.errors.invalid_expiration_date"),
  // @ts-expect-error: Flow to TS migration.
  TERMS: __("booking.global.agreement.terms_error"),
  // @ts-expect-error: Flow to TS migration.
  ID_NUMBER_TOO_LONG: __("forms.id_number_too_long"),
  // @ts-expect-error: Flow to TS migration.
  INVALID_CPF: __("forms.errors.invalid_cpf"),
  // @ts-expect-error: Flow to TS migration.
  INVALID_CNPJ: __("forms.errors.invalid_cnpj"),
  // @ts-expect-error: Flow to TS migration.
  AT_LEAST_ONE_NUMBER: __("forms.errors.at_least_one_number"),
  // @ts-expect-error: Flow to TS migration.
  USE_MAX_CHARACTERS: __("forms.errors.use_max_characters"),
  // @ts-expect-error: Flow to TS migration.
  USE_LATIN_ONLY: __("common.enter_only_latin_characters"),
} as const

export const PARTNER_TYPES = {
  B2B: "b2b",
  B2C: "b2c",
  B2B2C: "b2b2c",
  INTERNAL: "internal",
  UNKNOWN: "unknown",
} as const
